/**
 * SPA entry point.
 *
 * Imports the responsive stylesheet and boots the application shell into the
 * `#app` mount. Kept minimal so Vite's dev server and production build share a
 * single, framework-free entry.
 */
import "./styles.css";
import { startApp } from "./app";

const mount = document.getElementById("app");
if (mount === null) {
  throw new Error("Missing #app mount element.");
}
startApp(mount);
